const _registeredSectionLayouts = {};
export function getRegisteredSectionLayouts() {
    return _registeredSectionLayouts;
}
export function hasRegisteredSectionLayout(layoutName) {
    return _registeredSectionLayouts.hasOwnProperty(layoutName);
}
export function addRegisteredSectionLayout(registeredSectionLayout) {
    // if (_registeredSectionLayouts[registeredSectionLayout.name]) {
    // 	console.warn(
    // 		`_registeredSectionLayouts already contain a layout named ${
    // 			registeredSectionLayout.name
    // 		}, will override`
    // 	);
    // }
    _registeredSectionLayouts[registeredSectionLayout.name] =
        registeredSectionLayout;
}
//# sourceMappingURL=sectionLayoutDescriptions.js.map